(function () {

  // ─── Carousel initialiser ─────────────────────────────────────────────────
  // Wires up every .asc-products-pmc carousel on the page:
  //   • Prev / Next arrow buttons     → scrollBy one slide width
  //   • Nav-tab buttons (module-12)   → scrollTo specific slide
  //   • scroll event                  → sync active dot + active tab + arrow visibility

  function initCarousels() {
    document.querySelectorAll('.asc-products-pmc').forEach(function (pmc) {
      var track = pmc.querySelector('.asc-products-pmc-track');
      var prev  = pmc.querySelector('.asc-products-pmc-prev');
      var next  = pmc.querySelector('.asc-products-pmc-next');
      var dots  = pmc.querySelectorAll('.asc-products-pmc-dot');

      // Nav-tab buttons live in the element directly before .asc-products-pmc
      // (premium-module-12-nav-carousel only).  Scope to previousElementSibling
      // so multiple carousels on the same page don't share tab wiring.
      var prevSib = pmc.previousElementSibling;
      var tabsEl  = (prevSib && prevSib.classList.contains('asc-products-aplus-navc__tabs'))
        ? prevSib
        : null;
      var tabs = tabsEl ? tabsEl.querySelectorAll('.asc-products-aplus-navc__tab') : [];

      if (!track) return;

      var slideCount = Math.max(dots.length, tabs.length);
      var slideW = function () { return track.clientWidth; };

      // ── Prev / Next buttons ─────────────────────────────────────────────
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideW(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: slideW(), behavior: 'smooth' });
      });

      // ── Tab buttons → jump to specific slide ────────────────────────────
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          track.scrollTo({ left: i * slideW(), behavior: 'smooth' });
        });
      });

      // ── Sync dots, tabs, and arrow visibility on scroll ─────────────────
      function onScroll() {
        var idx = Math.round(track.scrollLeft / (slideW() || 1));

        dots.forEach(function (d, i) {
          d.style.background = i === idx ? 'rgba(0,0,0,.65)' : 'rgba(0,0,0,.2)';
        });

        tabs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === idx);
        });

        if (prev) prev.style.display = idx === 0 ? 'none' : '';
        if (next) next.style.display = idx >= slideCount - 1 ? 'none' : '';
      }

      track.addEventListener('scroll', onScroll, { passive: true });
      onScroll(); // set initial state (hides prev on slide 0)
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

})();


// ─── Gallery + Variant Selection ──────────────────────────────────────────────
// Handles:
//   • custom-asc-product-image-gallery.liquid  — thumbnail hover/click + gallery swap
//   • custom-asc-products-variant-selection.liquid — swatch hover/click + variant sync

(function () {

  // ── Product image gallery ──────────────────────────────────────────────────
  // Amazon-style image swap: pre-load all full-size images so the browser has
  // them cached, then swap src directly with no CSS transition — effectively
  // instant (matches Amazon's behaviour).
  //
  // Click thumbnail  → pins it as the active image.
  // Hover thumbnail  → previews that image; leaving reverts to the pinned image.
  // asc:variant-selected → rebuilds the full gallery for the new variant.

  function initAscProductGallery() {
    var gal = document.getElementById('asc-products-gal');
    if (!gal) return;

    var mainImg  = document.getElementById('asc-products-gal-main-img');
    var thumbsEl = gal.querySelector('.asc-products-gal__thumbs');
    if (!mainImg || !thumbsEl) return;

    // Load serialised variant image data written by the Liquid template
    var galleryData = null;
    var dataEl = document.getElementById('asc-products-gallery-data');
    if (dataEl) {
      try { galleryData = JSON.parse(dataEl.textContent); } catch (e) {
        console.warn('[asc-gallery] Could not parse gallery data JSON:', e);
      }
    }

    // Pre-load every full-size image for all variants so swaps are cache-hits
    if (galleryData && galleryData.variants) {
      Object.keys(galleryData.variants).forEach(function (vid) {
        var imgs = galleryData.variants[vid] || [];
        imgs.forEach(function (img) {
          var p = new Image();
          p.src = img.src;
        });
      });
    }

    // Pinned image — the last image deliberately clicked/tapped.
    var pinnedSrc = mainImg.src;
    var pinnedAlt = mainImg.alt;

    // Direct src swap — no transition, instant (like Amazon)
    function showMain(src, alt) {
      mainImg.src = src;
      mainImg.alt = alt || '';
    }

    // Toggle 2-column modifier when > 10 thumbs
    function syncWide() {
      var count = thumbsEl.querySelectorAll('.asc-products-gal__thumb').length;
      thumbsEl.classList.toggle('asc-products-gal__thumbs--wide', count > 10);
    }
    syncWide();

    // ── Click → pin this image ───────────────────────────────────────────────
    thumbsEl.addEventListener('click', function (e) {
      var thumb = e.target.closest('.asc-products-gal__thumb');
      if (!thumb) return;
      thumbsEl.querySelectorAll('.asc-products-gal__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      pinnedSrc = thumb.dataset.src;
      pinnedAlt = thumb.dataset.alt || '';
      showMain(pinnedSrc, pinnedAlt);
    });

    // ── Hover → preview without pinning ─────────────────────────────────────
    thumbsEl.addEventListener('mouseover', function (e) {
      var thumb = e.target.closest('.asc-products-gal__thumb');
      if (!thumb) return;
      showMain(thumb.dataset.src, thumb.dataset.alt || '');
    });

    thumbsEl.addEventListener('mouseout', function (e) {
      var thumb = e.target.closest('.asc-products-gal__thumb');
      if (!thumb || thumb.contains(e.relatedTarget)) return;
      showMain(pinnedSrc, pinnedAlt);
    });

    // ── Variant widget hover → preview that variant's first image ────────────
    document.addEventListener('asc:variant-preview', function (e) {
      if (!galleryData) return;
      var vid    = String(e.detail.variantId);
      var images = galleryData.variants[vid];
      if (!images || !images.length) return;
      showMain(images[0].src, images[0].alt || '');
    });

    document.addEventListener('asc:variant-preview-end', function () {
      showMain(pinnedSrc, pinnedAlt);
    });

    // ── Variant selected → rebuild gallery ──────────────────────────────────
    document.addEventListener('asc:variant-selected', function (e) {
      if (!galleryData) return;
      var vid    = String(e.detail.variantId);
      var images = galleryData.variants[vid]
                || galleryData.variants[String(galleryData.primaryVariantId)]
                || [];
      if (!images.length) return;
      rebuildGallery(images);
    });

    function rebuildGallery(images) {
      thumbsEl.innerHTML = '';
      images.forEach(function (img, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'asc-products-gal__thumb' + (i === 0 ? ' is-active' : '');
        btn.dataset.src   = img.src;
        btn.dataset.thumb = img.thumb;
        btn.dataset.alt   = img.alt;
        btn.setAttribute('aria-label', img.alt || '');

        var imgEl = document.createElement('img');
        imgEl.src   = img.thumb;
        imgEl.alt   = img.alt || '';
        imgEl.width = 54;
        imgEl.setAttribute('loading', 'lazy');
        btn.appendChild(imgEl);
        thumbsEl.appendChild(btn);
      });

      syncWide();

      pinnedSrc = images[0].src;
      pinnedAlt = images[0].alt || '';
      showMain(pinnedSrc, pinnedAlt);
    }
  }

  // ── Variant swatch selection ───────────────────────────────────────────────
  // Click swatch  → selects variant, permanently updates label, fires gallery swap.
  // Hover swatch  → temporarily previews that variant's name and gallery image;
  //                 leaving the widget reverts both to the selected variant.
  // Pagination    → built dynamically when > 4 variants on desktop.
  //                 Each page shows SWATCHES_PER_PAGE swatches.
  //                 On mobile all swatches are always visible (CSS override).

  var SWATCHES_PER_PAGE = 8;

  function initAscVariantSelection() {
    document.querySelectorAll('.asc-products-vs').forEach(function (vs) {
      var labelVal    = vs.querySelector('.asc-products-vs__selected-val');
      var swatchesEl  = vs.querySelector('.asc-products-vs__swatches');
      var paginationEl = vs.querySelector('.asc-products-vs__pagination');

      var selectedLabel = labelVal ? labelVal.textContent : '';
      var swatchEls = swatchesEl
        ? Array.from(swatchesEl.querySelectorAll('.asc-products-vs__swatch'))
        : [];

      // ── Pagination ─────────────────────────────────────────────────────────
      var currentPage  = 0;
      var totalPages   = Math.ceil(swatchEls.length / SWATCHES_PER_PAGE);
      var pagingActive = false;

      function buildPagination() {
        if (!paginationEl || swatchEls.length <= 4 || totalPages <= 1) return;
        var html = '<button class="asc-products-vs__nav-btn asc-products-vs__nav-btn--prev" type="button" aria-label="Previous page">&#8249;</button>';
        html += '<span class="asc-products-vs__page-nums">';
        for (var i = 0; i < totalPages; i++) {
          html += '<button class="asc-products-vs__page-num' + (i === 0 ? ' is-active' : '') + '" type="button" data-page="' + i + '">' + (i + 1) + '</button>';
        }
        html += '</span>';
        html += '<button class="asc-products-vs__nav-btn asc-products-vs__nav-btn--next" type="button" aria-label="Next page">&#8250;</button>';
        paginationEl.innerHTML = html;
        paginationEl.removeAttribute('aria-hidden');

        paginationEl.addEventListener('click', function (e) {
          var pageBtn = e.target.closest('.asc-products-vs__page-num');
          if (pageBtn) { showPage(parseInt(pageBtn.dataset.page, 10)); return; }
          var prev = e.target.closest('.asc-products-vs__nav-btn--prev');
          if (prev && !prev.disabled && currentPage > 0) { showPage(currentPage - 1); return; }
          var next = e.target.closest('.asc-products-vs__nav-btn--next');
          if (next && !next.disabled && currentPage < totalPages - 1) { showPage(currentPage + 1); }
        });
      }

      function showPage(page) {
        currentPage = page;
        swatchEls.forEach(function (s, i) {
          s.style.display = Math.floor(i / SWATCHES_PER_PAGE) === page ? '' : 'none';
        });
        if (!paginationEl) return;
        paginationEl.querySelectorAll('.asc-products-vs__page-num').forEach(function (btn, i) {
          btn.classList.toggle('is-active', i === page);
        });
        var prevBtn = paginationEl.querySelector('.asc-products-vs__nav-btn--prev');
        var nextBtn = paginationEl.querySelector('.asc-products-vs__nav-btn--next');
        if (prevBtn) prevBtn.disabled = page === 0;
        if (nextBtn) nextBtn.disabled = page === totalPages - 1;
      }

      function enablePaging() {
        if (pagingActive) return;
        pagingActive = true;
        vs.classList.add('asc-products-vs--paged');
        buildPagination();
        showPage(currentPage);
      }

      function disablePaging() {
        if (!pagingActive) return;
        pagingActive = false;
        vs.classList.remove('asc-products-vs--paged');
        swatchEls.forEach(function (s) { s.style.display = ''; });
      }

      // Only paginate on desktop; mobile shows all via CSS
      if (swatchEls.length > 4 && totalPages > 1) {
        var mq = window.matchMedia('(min-width: 750px)');
        function handleMQ(e) { e.matches ? enablePaging() : disablePaging(); }
        if (mq.addEventListener) mq.addEventListener('change', handleMQ);
        else if (mq.addListener)  mq.addListener(handleMQ);   // Safari < 14
        handleMQ(mq);
      }

      // ── Click → select variant ─────────────────────────────────────────────
      vs.addEventListener('click', function (e) {
        var swatch = e.target.closest('.asc-products-vs__swatch');
        if (!swatch) return;
        if (swatch.getAttribute('aria-disabled') === 'true') return;

        var variantId = swatch.dataset.variantId;
        var label     = swatch.dataset.label || '';

        swatchEls.forEach(function (s) {
          s.classList.remove('is-active');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');

        selectedLabel = label;
        if (labelVal) labelVal.textContent = label;

        // Sync Ride theme select so price/availability update
        var themeSelect = document.querySelector(
          'select[name="id"], input[name="id"][type="hidden"]'
        );
        if (themeSelect) {
          themeSelect.value = variantId;
          themeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var radio = vs.querySelector('input[value="' + variantId + '"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        document.dispatchEvent(new CustomEvent('asc:variant-selected', {
          bubbles: true,
          detail: { variantId: parseInt(variantId, 10) }
        }));
      });

      // ── Hover → preview variant name + gallery image ──────────────────────
      vs.addEventListener('mouseover', function (e) {
        var swatch = e.target.closest('.asc-products-vs__swatch');
        if (!swatch) return;
        if (labelVal) labelVal.textContent = swatch.dataset.label || '';
        document.dispatchEvent(new CustomEvent('asc:variant-preview', {
          detail: { variantId: parseInt(swatch.dataset.variantId, 10) }
        }));
      });

      // Revert label when cursor leaves a swatch
      vs.addEventListener('mouseout', function (e) {
        var swatch = e.target.closest('.asc-products-vs__swatch');
        if (!swatch || swatch.contains(e.relatedTarget) || !labelVal) return;
        labelVal.textContent = selectedLabel;
      });

      // Revert gallery only when cursor fully exits the entire widget
      vs.addEventListener('mouseout', function (e) {
        if (vs.contains(e.relatedTarget)) return;
        document.dispatchEvent(new CustomEvent('asc:variant-preview-end'));
      });
    });
  }

  // ── Product price display ──────────────────────────────────────────────────
  // Listens for asc:variant-selected (click) and asc:variant-preview (hover).
  // Updates the price elements rendered by custom-asc-products-price.liquid
  // without a page reload. Hover previews price; click makes it permanent.

  function initAscProductPrice() {
    var currentEl = document.getElementById('asc-products-price-current');
    var compareEl = document.getElementById('asc-products-price-compare');
    var dataEl    = document.getElementById('asc-products-price-data');
    if (!currentEl || !dataEl) return;

    var priceData = null;
    try { priceData = JSON.parse(dataEl.textContent); } catch (e) {
      console.warn('[asc-price] Could not parse price data JSON:', e);
    }
    if (!priceData) return;

    // Track the last permanently-selected variant price for revert on hover-end
    var selectedPriceData = null;

    function updatePriceDisplay(v) {
      if (!v) return;

      currentEl.textContent = v.price_formatted;

      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent  = v.compare_at_price_formatted;
          compareEl.style.display = '';
        } else {
          compareEl.textContent  = '';
          compareEl.style.display = 'none';
        }
      }
    }

    // Click → select variant and lock price
    document.addEventListener('asc:variant-selected', function (e) {
      var vid = String(e.detail.variantId);
      var v   = priceData[vid];
      if (!v) return;

      selectedPriceData = v;
      updatePriceDisplay(v);
    });

    // Hover → preview price without locking
    document.addEventListener('asc:variant-preview', function (e) {
      var vid = String(e.detail.variantId);
      var v   = priceData[vid];
      if (!v) return;

      updatePriceDisplay(v);
    });

    // Hover-end → revert to selected variant's price
    document.addEventListener('asc:variant-preview-end', function () {
      if (selectedPriceData) {
        updatePriceDisplay(selectedPriceData);
      }
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  // Variant "Buy on Amazon" link sync: rewrite the button href to the selected
  // variant's ASIN on asc:variant-selected, falling back to the product-level
  // ASIN when the variant has none. Selection only (not hover) so the buy link
  // never changes from a mere mouseover.
  // 2026-07-27 the anchor now carries a variantId -> fully formed affiliate URL map in
  // data-affiliate-map, written by custom-affiliate-button.liquid. Previously this
  // assembled an Amazon URL from an ASIN plus a tag held in a data attribute; building
  // the whole URL server-side keeps merchant-specific logic and any tracking key out of
  // client-side code and works for every retailer, not just Amazon.
  function initAscVariantAffiliateLink() {
    document.addEventListener('asc:variant-selected', function (e) {
      var vid = String(e.detail.variantId);

      document.querySelectorAll('[data-affiliate-link]').forEach(function (el) {
        var urlMap = {};
        try {
          urlMap = JSON.parse(el.getAttribute('data-affiliate-map') || '{}');
        } catch (err) {
          return;
        }
        // Only the link whose own product owns this variant is rewritten, so a
        // collection page can never point one card at another product's destination.
        var url = urlMap[vid];
        if (url) el.href = url;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAscProductGallery();
      initAscVariantSelection();
      initAscProductPrice();
      initAscVariantAffiliateLink();
    });
  } else {
    initAscProductGallery();
    initAscVariantSelection();
    initAscProductPrice();
    initAscVariantAffiliateLink();
  }

})();
